import { render, staticRenderFns } from "./Full.vue?vue&type=template&id=4e705a92&scoped=true"
import script from "./Full.vue?vue&type=script&lang=js"
export * from "./Full.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e705a92",
  null
  
)

export default component.exports